import { useFormikContext } from 'formik';
import { useTranslation } from '@shared/utils/i18n';
import { useGetApiTransactionsSaldoAbonentId } from '@/shared/api/orval/transactions/transactions';

export interface UseCalculateDebtReturn {
  isDisabled: boolean;
  isPending: boolean;
  initialDebtText: string;
  resultDebtText: string;
}

interface FormikValues {
  abonent: {
    id?: number;
  };
  amount: number;
  group: {
    group_id?: number;
  };
}

export const useCalculateDebt = (): UseCalculateDebtReturn => {
  const { t } = useTranslation();
  const { values } = useFormikContext<FormikValues>();
  const transformData = (response: any) => {
    const result = response.result?.services?.filter((service: any) => service.serviceId === values.group?.group_id)[0]
      ?.debt;
    return result;
  };

  const { data: currentDebt, isPending } = useGetApiTransactionsSaldoAbonentId(values.abonent?.id || 0, {
    query: {
      select: transformData,
      enabled: Boolean(values.abonent?.id)
    }
  });

  const resultDebt = (Number(currentDebt) || 0) + (Number(values.amount) ?? 0);

  const initialDebtText = () => {
    const debt = Math.round(currentDebt * 100) / 100;
    if (!!currentDebt && currentDebt < 0) return t('payments:currentProfit', { value: Math.abs(debt) });

    if (!currentDebt || Number.isNaN(currentDebt)) return t('payments:currentDebt', { value: 0 });

    return t('payments:currentDebt', { value: debt });
  };

  const resultDebtText = () => {
    const result = Math.round(resultDebt * 100) / 100;
    if (!!resultDebt && resultDebt < 0) return t('payments:resultProfit', { value: Math.abs(result) });

    if (!resultDebt || Number.isNaN(resultDebt)) return t('payments:resultDebt', { value: 0 });

    return t('payments:resultDebt', { value: result });
  };

  return {
    isDisabled: !values.abonent?.id,
    isPending,
    resultDebtText: resultDebtText(),
    initialDebtText: initialDebtText()
  };
};
